import { createFileRoute } from '@tanstack/react-router';

import { PracticeHub } from '@/features/Practice/PracticeHub';

export const Route = createFileRoute('/_student/courses/$batchId/practice/')({
  component: PracticeHubRoute,
});

function PracticeHubRoute() {
  const { batchId } = Route.useParams();
  return <PracticeHub batchId={batchId} />;
}
